import React from 'react';
import { LegalPage } from './LegalPage';

const FALLBACK_HTML = `
<h1>Legal Notice</h1>
<p><em>Last updated: 24/04/2026</em></p>

<h2>Website owner</h2>
<p>This website is owned and operated by:</p>
<p><strong>SitgesVibes</strong><br><a href="mailto:info@sitgesvibes.com">info@sitgesvibes.com</a><br>Spain</p>

<h2>Purpose of the website</h2>
<p>SitgesVibes provides curated information about experiences, activities, tours and things to do in Sitges and nearby areas.</p>

<h2>External links and bookings</h2>
<p>This website includes links to external booking platforms and third-party providers. We do not directly organise, operate, sell or manage the experiences listed unless expressly stated.</p>
<p>Prices, availability, booking conditions, cancellation policies and customer service are managed by each external provider.</p>

<h2>Affiliate disclosure</h2>
<p>Some links on this website may be affiliate links. This means we may earn a commission if you make a booking through those links, at no extra cost to you.</p>

<h2>Liability</h2>
<p>We try to keep the information on this website accurate and up to date, but we cannot guarantee that all prices, schedules, availability or descriptions are always current. Users should verify all details directly with the external provider before booking.</p>

<h2>Intellectual property</h2>
<p>All website content, including text, design, branding and original images, belongs to SitgesVibes unless otherwise stated. Third-party trademarks, logos and content belong to their respective owners.</p>

<h2>Contact</h2>
<p>For any legal or general enquiry, contact us at: <a href="mailto:info@sitgesvibes.com">info@sitgesvibes.com</a></p>
`;

export function LegalNoticePage() {
  return (
    <LegalPage
      contentKey="legal_notice"
      fallbackHtml={FALLBACK_HTML}
      testId="legal-notice-page"
      titleKey="legal_legal_notice"
      seoTitle="Legal Notice | SitgesVibes"
      seoDescription="Legal information about SitgesVibes: website ownership, purpose, affiliate disclosure and external booking platform terms."
    />
  );
}

export default LegalNoticePage;
